import React from "react";
import { Box, TextField, Button, Typography, Link, Card, Divider } from "@mui/material";
import SthanickLogo from "../../assets/images/Home_page_image/Login/LoginLogo.png";
import { useNavigate } from "react-router-dom";

const OtpVerification = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#ffffff",
        padding: "16px",
      }}
    >
      <Box 
        component="img" 
        src={SthanickLogo} 
        alt="Sthanick Logo" 
        sx={{ 
          mb: 2, 
          width: "180px", 
          "@media (min-width:600px)": { width: "220px" } 
        }} 
      />
      
      <Card
        sx={{
          padding: "16px",
          width: "100%",
          maxWidth: "350px",
          boxShadow: "0px 2px 8px rgba(0,0,0,0.2)",
          borderRadius: "8px",
        }}
      >
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, textAlign: "center" }}>
          Authentication Required
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, fontWeight: "bold", textAlign: "center" }}>
          IN +91878767656 <span style={{color:'blue'}}><Link href="#">Change</Link></span>
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, textAlign: "center" }}>
          We have sent a One Time Password (OTP) to the mobile number above. Please enter it to complete verification.
        </Typography>
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
          Enter OTP
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Mobile number or email"
          sx={{ mb: 2 }}
        />
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#e45026",
            color: "white",
            width: "100%",
            padding: "10px",
            fontSize: "14px",
            mb: 2,
            borderRadius: "50px",
            '&:hover': { backgroundColor: "#e45026" },
          }}
          onClick={() => navigate("/profileinfo")}
        >
          Continue
        </Button>
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <Link href="#" sx={{ color: 'blue' }}>Resend OTP</Link>
        </Box>

        {/* Divider with "or" in between */}
        <Box sx={{ display: "flex", alignItems: "center", my: 2 }}>
          <Divider sx={{ flex: 1 }} />
          <Typography sx={{ mx: 1, fontSize: "14px", color: "#555" }}>or</Typography>
          <Divider sx={{ flex: 1 }} />
        </Box>

        <Button
          variant="contained"
          sx={{
            backgroundColor: "#e45026",
            color: "white",
            width: "100%",
            padding: "10px",
            fontSize: "14px",
            mb: 2,
            borderRadius: "50px",
            '&:hover': { backgroundColor: "#e45026" },
          }}
        >
          Send OTP to WhatsApp
        </Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#e45026",
            color: "white",
            width: "100%",
            padding: "10px",
            fontSize: "14px",
            mb: 2,
            borderRadius: "50px",
            '&:hover': { backgroundColor: "#e45026" },
          }}
        >
          Sign in with your password
        </Button>
      </Card>

      <Box sx={{ mt: 2, display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 2 }}>
        <Link href="#" sx={{ fontSize: "12px" }}>Conditions of Use</Link>
        <Link href="#" sx={{ fontSize: "12px" }}>Privacy Notice</Link>
        <Link href="#" sx={{ fontSize: "12px" }}>Help</Link>
      </Box>
      <Typography variant="body2" sx={{ mt: 1, color: "#767676", textAlign: "center", fontSize: "12px" }}>
        © 1996-2024, Sthanick.com, Inc. or its affiliates
      </Typography>
    </Box>
  );
};

export default OtpVerification;